/*
  Copyright 2019 Bit Factory, Inc.
  This Source Code Form is subject to the terms of the Mozilla Public
  License, v. 2.0. If a copy of the MPL was not distributed with this
  file, You can obtain one at http://mozilla.org/MPL/2.0/.
*/
import { QurageLink } from './link';
import { FirebaseRpcBackend } from '../rpc-backend';
import { DeepLink } from '../deep-link';
import { RpcClient } from '../providers/rpc-client';
import { FirebaseAdapter } from '../firebase';
import { deepLink as deepLinkConfig } from '../config';
export class QurageLinkFactory {
    static create(settings) {
        this.validateSettings(settings);
        const { endpoint, dappName, netVersion } = settings;
        return new QurageLink(endpoint, dappName ? dappName : document.title, netVersion ? netVersion : '1', new FirebaseRpcBackend(new FirebaseAdapter()), new DeepLink(deepLinkConfig), new RpcClient(endpoint));
    }
    static validateSettings(settings) {
        if (!settings) {
            throw new Error('QurageLinkFactory: options is required');
        }
        if (!settings.endpoint) {
            throw new Error('QurageLinkFactory: options.endpoint is required');
        }
    }
}
